import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

const CARDS = [
  { slug: "automotive", key: "automotive", img: "https://images.unsplash.com/photo-1635975229704-0a420e777a56" },
  { slug: "aviation", key: "aviation", img: "https://images.pexels.com/photos/28776068/pexels-photo-28776068.jpeg" },
  { slug: "yachting", key: "yachting", img: "https://images.unsplash.com/photo-1597609490757-5fc92ead5cb1" },
  { slug: "real-estate", key: "realEstate", img: "https://images.pexels.com/photos/13203179/pexels-photo-13203179.jpeg" },
];

const fade = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.12, duration: 0.9, ease: [0.22, 1, 0.36, 1] } }),
};

export const Collections = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  return (
    <section id="collections" data-testid="collections" className="bg-white py-24 md:py-36 px-6 lg:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="font-sans text-gold text-[11px] tracking-luxury uppercase mb-5">
            {t("collections.label")}
          </motion.p>
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9 }} className="font-serif text-navy text-4xl md:text-6xl leading-tight">
            {t("collections.hA")} <span className="italic text-gold">{t("collections.hB")}</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {CARDS.map((c, i) => (
            <motion.button
              key={c.slug}
              custom={i}
              variants={fade}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              onClick={() => { navigate(`/collections/${c.slug}`); window.scrollTo(0, 0); }}
              data-testid={`collection-card-${c.slug}`}
              className="group relative h-[380px] md:h-[460px] overflow-hidden rounded-xl border border-transparent hover:border-gold transition-all duration-500 text-left"
            >
              <img src={c.img} alt={t(`col.${c.key}.title`)} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent group-hover:from-navy/95 transition-all duration-500" />
              <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-10">
                <span className="font-sans text-gold text-[10px] tracking-luxury uppercase mb-3">0{i + 1}</span>
                <h3 className="font-serif text-white text-3xl md:text-4xl mb-3">{t(`col.${c.key}.title`)}</h3>
                <p className="font-sans text-white/70 text-sm max-w-sm leading-relaxed opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                  {t(`col.${c.key}.text`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 font-sans text-gold text-[11px] tracking-wide-lux uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  {t("collections.view")}
                </span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
